export default __webpack_public_path__ + "static/media/PressureLiveSet.c6aec0ca.svg";